import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    ////////////////////////////////////////////////////////
    isShownSettings: false,
    wallpaper: "automatic",
    theme: "light", // Default theme
    ////////////////////////////////////////////////////////
    // Active window
    activeWindow: "Desktop",
    // Z-index counter
    zIndex: 2,
    // Portfolio window
    isShownPortfolio: false,
    isFullscreenPortfolio: false,
    // Game One window
    isShownGame: false,
    isFullscreenGame: false,
    // Photo Editor window
    isShownPhotoEditor: false,
    isFullscreenPhotoEditor: false,
    // Photo window
    isShownPhotos: false,
    isFullscreenPhotos: false,
    // Bio window
    isShownBio: false,
    isLoadingBio: false,
    isFullscreenBio: false,
    // Stickies window
    isShownStickies: false,
    isFullscreenStickies: false,
    notepadData: "Write you thoughts here...",
    // Mail window
    isShownMail: false,
    isFullscreenMail: false,
    mailContent: "",
    mailSender: "",
    mailSubject: "New Message",
    // Simulator window
    isShownSimulator: false,
    //Launchpad view
    isShownLaunchpad: false,
  },
  mutations: {
    toggleShownSettings(state, shown) { state.isShownSettings = shown; },
    selectTheme(state, theme) {
      if (!["light", "dark"].includes(theme)) return;
      state.theme = theme;
      localStorage.setItem("theme", theme);
      document.documentElement.setAttribute("data-theme", theme);
    },
    setWallpaper(state, id) {
      if (!["automatic", "desert", "night"].includes(id)) return;
      state.wallpaper = id;
      localStorage.setItem("wallpaper", id);
    },
    ////////////////////////////////////////////////////////
    toggleTheme(state) {
      state.theme = state.theme === "light" ? "dark" : "light";
      localStorage.setItem("theme", state.theme); // Save to localStorage
      document.documentElement.setAttribute("data-theme", state.theme);
    },
    setTheme(state, theme) {
      state.theme = theme;
      document.documentElement.setAttribute("data-theme", theme);
    },
    ////////////////////////////////////////////////////////

    toggleShownPortfolio(state, shownBool) {
      state.isShownPortfolio = shownBool;
    },
    toggleFullscreenPortfolio(state) {
      state.isFullscreenPortfolio = !state.isFullscreenPortfolio;
    },
    toggleShownGame(state, shownBool) {
      state.isShownGame = shownBool;
    },
    toggleFullscreenGame(state) {
      state.isFullscreenGame = !state.isFullscreenGame;
    },
    toggleShownPhotoEditor(state, shownBool) {
      state.isShownPhotoEditor = shownBool;
    },
    toggleFullscreenPhotoEditor(state) {
      state.isFullscreenPhotoEditor = !state.isFullscreenPhotoEditor;
    },
    toggleShownPhotos(state, shownBool) {
      state.isShownPhotos = shownBool;
    },
    toggleFullscreenPhotos(state) {
      state.isFullscreenPhotos = !state.isFullscreenPhotos;
    },
    toggleShownStickies(state, shownBool) {
      state.isShownStickies = shownBool;
    },
    toggleFullscreenStickies(state) {
      state.isFullscreenStickies = !state.isFullscreenStickies;
    },
    toggleShownBio(state, shownBool) {
      state.isShownBio = shownBool;
      if (shownBool) state.isLoadingBio = false;
    },
    setLoadingBio(state, loading) {
      state.isLoadingBio = loading;
    },
    toggleFullscreenBio(state) {
      state.isFullscreenBio = !state.isFullscreenBio;
    },
    zIndexIncrement(state, top) {
      console.log("zindex upgraded");
      state.zIndex += 1;
      document.getElementById(top).style.zIndex = state.zIndex;
    },
    changeActiveWindow(state, window) {
      state.activeWindow = window;
    },
    updateNotepad(state, local) {
      state.notepadData = local;
    },
    toggleShownMail(state, shownBool) {
      state.isShownMail = shownBool;
    },
    toggleFullscreenMail(state) {
      state.isFullscreenMail = !state.isFullscreenMail;
    },
    updateMail(state, local) {
      state.isShownMail = local;
    },
    updateMailSubject(state, local) {
      state.mailSubject = local;
    },
    updateMailContent(state, local) {
      state.mailContent = local;
    },
    updateMailSender(state, local) {
      state.mailSender = local;
    },
    toggleShownSimulator(state, shownBool) {
      state.isShownSimulator = shownBool;
    },
    toggleLaunchpad(state) {
      state.isShownLaunchpad = !state.isShownLaunchpad;
    },
  },
  actions: {
    ////////////////////////////////////////////////////////
    initializeTheme({ commit }) {
      const savedTheme = localStorage.getItem("theme") || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
      commit("setTheme", ["light", "dark"].includes(savedTheme) ? savedTheme : "light");
      commit("setWallpaper", localStorage.getItem("wallpaper") || "automatic");
    },
    ////////////////////////////////////////////////////////
  },
  getters: {
    ////////////////////////////////////////////////////////
    theme: (state) => state.theme,
    ////////////////////////////////////////////////////////

    isShownLaunchpad: (state) => {
      return state.isShownLaunchpad;
    },
    isShownPortfolio: (state) => {
      return state.isShownPortfolio;
    },
    isFullscreenPortfolio: (state) => {
      return state.isFullscreenPortfolio;
    },
    isShownGame: (state) => {
      return state.isShownGame;
    },
    isFullscreenGame: (state) => {
      return state.isFullscreenGame;
    },
    isShownPhotoEditor: (state) => {
      return state.isShownPhotoEditor;
    },
    isFullscreenPhotoEditor: (state) => {
      return state.isFullscreenPhotoEditor;
    },
    isShownPhotos: (state) => {
      return state.isShownPhotos;
    },
    isFullscreenPhotos: (state) => {
      return state.isFullscreenPhotos;
    },
    isShownColorization: (state) => {
      return state.isShownColorization;
    },
    isFullscreenColorization: (state) => {
      return state.isFullscreenColorization;
    },
    isShownStickies: (state) => {
      return state.isShownStickies;
    },
    isFullscreenStickies: (state) => {
      return state.isFullscreenStickies;
    },
    isShownBio: (state) => {
      return state.isShownBio;
    },
    isFullscreenBio: (state) => {
      return state.isFullscreenBio;
    },
    zIndex: (state) => {
      return state.zIndex;
    },
    activeWindow: (state) => {
      return state.activeWindow;
    },
    notepadData: (state) => {
      return state.notepadData;
    },
    isShownMail: (state) => {
      return state.isShownMail;
    },
    isFullscreenMail: (state) => {
      return state.isFullscreenMail;
    },
    mailContent: (state) => {
      return state.mailContent;
    },
    mailSubject: (state) => {
      return state.mailSubject;
    },
    mailSender: (state) => {
      return state.mailSender;
    },
    isShownSimulator: (state) => {
      return state.isShownSimulator;
    },
  },
});
